import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import { getGoals } from './thunks/goalThunks';
import { useAppDispatch } from './hooks';
import Naruhone from './components/Naruhone';
import { createBrowserRouter, Link, Outlet, RouterProvider } from 'react-router-dom';
import { ErrorPage } from './routes/ErrorPage';
import DailyDash from './components/DailyDash';
import { ProtectedRoute } from './routes/ProtectedRoute';
import Login from './authentication/Login';
import SignUp from './authentication/SignUp';
import LionelHomePage from './pages/LionelHomePage';
import DashboardEditorPage from './pages/DashboardEditorPage';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './authentication/firebase';
import { clearUser, setUser } from './store/authSlice';
import DebugSection from './components/debug/DebugSection';
import Gridstacktest from './components/dashboard/Dashboard';
import { setGridHomePage } from './store/dashboardSlice';
import { fetchHomePage, fetchNaruhoneData } from './thunks/dashboardThunk';
import apiServices from './api/apiService';
import { getUserData } from './thunks/authThunk';
import TestPage from './pages/TestPage';
import Navbar from './components/Navbar';
import ResponsiveColorWidget from './components/debug/ResponsiveColorWidget';
import Footer from './components/Footer';


const AppLayout = () => {
    const scrollRef = useRef(null);
  // const [scrolled, setScrolled] = useState(false);
  // useEffect(() => {
  //   const scrollEl = scrollRef.current as any;
  //   if (!scrollEl) return;

  //   const onScroll = () => {
  //     setScrolled(scrollEl.scrollTop > 10);
  //   };

  //   scrollEl.addEventListener("scroll", onScroll);
  //   return () => scrollEl.removeEventListener("scroll", onScroll);
  // }, []);

  return <div className="flex flex-col h-screen">
      <div className='hidden sm:block fixed top-0 left-0 right-0 z-50'>
        <Navbar scrolled={false} />
      </div>
      <main ref={scrollRef} className="flex-1 overflow-y-auto md:pt-16 bg-[#0F172A]">
        {/* <DebugSection /> */}
        
    {/* <Naruhone/> */}
      <Outlet />
      <Footer />
      </main>
  </div>;

}

const router = createBrowserRouter([{
  path: "/",
  element: <AppLayout />,
  errorElement: <ErrorPage />,
  children: [
    {
      path: "/",
      element: <LionelHomePage />,
    },
    {
      path: "dailies",
      element: <ProtectedRoute>
        <DailyDash />
      </ProtectedRoute>,
    },
    {
      path: "dailiespublic",
      element: <DailyDash />,
    },
    {
      path: "login",
      element: <Login />
    },
    {
      path: "signup",
      element: <SignUp />,
      loader: () => { return "aaa" }
    },
    {
      path: "custom/:id",
      element: <DailyDash />
    },
    {
      path: "edit",
      element: <ProtectedRoute>
        <DashboardEditorPage />
      </ProtectedRoute>,
    },
    {
      path: "test",
      element: <TestPage />
    }
  ]
}]);





function App() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Set up the auth state listener when the app initializes
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const idToken = await user.getIdToken();
        const sanitizedUser = { uid: user.uid, email: user.email }; // Clean up the user object
        dispatch(setUser({ user: sanitizedUser, idToken })); // Only pass serializable data
        dispatch(getUserData());
      } else {
        dispatch(clearUser());
      }
    });

    // Clean up the listener when the component unmounts
    return () => unsubscribe();
  }, [dispatch]);
  //Check if homepagedata needs to be updated.
  useEffect(() => {
    checkHomePageCacheUpdate();
    getNaruhoneData();

  }, []);

  const getNaruhoneData = async () => {
    dispatch(fetchNaruhoneData());
  }

  const checkHomePageCacheUpdate = async () => {
    // localStorage.
    const cachedHomePage = JSON.parse(localStorage.getItem("gridHomePage") || "{}");

    let latestVersion = -1;
    try {
      const response = await apiServices.dashboard.getHomePageVersion();
      latestVersion = response.version;
    } catch (e) {

    }


    //if latest version fails(its still null) then we assume the whole backend is failed, and therefore load the cache, but if that also doesnt exist, load a default homepage that is in the app itself.
    //
    if (latestVersion === -1) {
      if (Object.keys(cachedHomePage).length > 0) {
        dispatch(setGridHomePage(cachedHomePage.dashboard));
      }
      else {
        //load default here if fetching version number fails.
      }
    } else {
      // check cache with version and if they are the same load the cache, otherwise try fetch the new homepage and update the version on localstorage side.
      if (Object.keys(cachedHomePage).length > 0 && cachedHomePage.version === latestVersion) {
        console.log("already cached");
        dispatch(setGridHomePage(cachedHomePage.dashboard));
      } else {
        console.log("fetching new.");
        //fetch the homepage
        dispatch(fetchHomePage()).then((action) => {
          if (action.payload) {
            let cacheHomepageDashboard = {
              version: latestVersion,
              dashboard: action.payload
            };
            console.log(cacheHomepageDashboard);
            localStorage.setItem('gridHomePage', JSON.stringify(cacheHomepageDashboard));
          }
        });

      }
    }





  }


  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
